export const SET_PLUGINS = 'SET_PLUGINS';
export const SET_PLUGIN_LIST = 'SET_PLUGIN_LIST';

export function setPlugins(plugins) {
  return {
    type: SET_PLUGINS,
    payload: plugins,
  };
}

export function setPluginList(list) {
  return {
    type: SET_PLUGIN_LIST,
    payload: list,
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/plugin/actions.js
 **/